//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

import { GridDetailsSettings, GridDetailsController } from '../../common/grid-details/grid-details.directive.controller'
import { i18n } from '../../common/i18n/common.i18n'
import { MapOptions, Map, MapLegendItem } from '../../common/map2/map.directive.controller'
import { EventsNames } from '../../../helpers/events-names'
import { CommonHelper, CorrelationType } from '../../../helpers/common-helper'
import { OpMarker, OpRange, OpPolygon, OpCoord } from '../../../models/custom/op-map-area'
import { KnownColor } from '../../../models/common/known-colors'
import { MapHelper } from '../../../helpers/map-helper'
import { IUserSession } from '../../../helpers/user-session'
import { Enums } from '../../../models/common'
import { DashboardMapLegendItem, DashboardMapPolygon, DashboardMapRange } from '../../api/api.models'
import { SystemService } from '../../../services/system'
import { IMRBaseControlDirectiveController } from '../../../modules/common/base'

interface MapControllerScope extends ng.IScope {
    data: {
        id: number
        shortDetailsEnabled: boolean,
        referenceType: number,
        correlationType: number,
        legendItems: DashboardMapLegendItem[],
        iconDict: any,
        markers: any[], // TODO: otypować jak będzie poprawiona wersja w WS
        polygons: OpPolygon[]
        ranges: OpRange[]
        interaction: Enums.MapInteractionType
    }
    shortDetailsSettings: GridDetailsSettings
    mapOptions: MapOptions
}

export interface MapSource {
    markers: OpMarker[],
    polygons: OpPolygon[],
    ranges: OpRange[]
}

export class MapController extends IMRBaseControlDirectiveController {
    private mapDeferred = $.Deferred<Map>()
    private _markers: any[]
    private _setMarkers: OpMarker[] = []
    private intervalSourceUpdate: boolean = false
    private markersOnMap: OpMarker[] = []

    constructor(
        protected $scope: MapControllerScope,
        protected $q: ng.IQService,
        protected $timeout: ng.ITimeoutService,
        protected userSession: IUserSession,
        private systemService: SystemService
    ) {
        super()

        if ($scope.data == null || $scope.data == undefined) {
            console.error('Data can\'t be null in dashboard map control')
        }

        if ($scope.data.shortDetailsEnabled && $scope.data.referenceType) {
            $scope.shortDetailsSettings = GridDetailsController.getOptionsByReferenceType($scope.data.referenceType)
            $scope.shortDetailsSettings.noDataText = i18n('Common', 'ClickMarkerToShowDetails')
            $scope.shortDetailsSettings.measurmentIdSaveTo = "DashboardMapController" + $scope.data.referenceType
        }

        $scope.$on(EventsNames.DASHBOARD_MAP_MARKER_CLICKED, (event: ng.IAngularEvent, ...args: any[]) => {
            let selectedMarker = args[0]
            if ($scope.shortDetailsSettings) $scope.shortDetailsSettings.objects = [selectedMarker]
        })

        $scope.$on(EventsNames.DASHBOARD_UPDATE_MAP_SOURCE + $scope.data.id, (event, ...args) => {
            const source: MapSource = args[0] as MapSource
            this.intervalSourceUpdate = true

            if (source != null) {
                if (this.$scope.mapOptions.isFiltered != true) {
                    this.updateMapSource(source, false, false)
                    this.markersOnMap = source.markers
                } else {
                    this._markers = source.markers
                }
            }

            setTimeout(() => {
                this.$scope.$root.$broadcast(EventsNames.DASHBOARD_MAP_MARKERS_COUNT_CHANGED, this.markersOnMap, this.$scope.data.referenceType)
                this.intervalSourceUpdate = false
            }, 500)
        })

        const setMapOptions = () => {
            this.mapDeferred = $.Deferred<Map>()
            $scope.mapOptions = null

            $timeout(() => {
                MapHelper
                    .getDefaultOptions(this.userSession.getDataProvider())
                    .then((mapOptions: MapOptions) => {
                        mapOptions.hideCloseButton = true
                        mapOptions.legendItems = $scope.data.legendItems ?
                            $scope.data.legendItems.map((m: DashboardMapLegendItem) => <MapLegendItem>{
                                color: m.color,
                                description: m.description ? m.description.description : '',
                                icon: m.icon ? m.icon.fileBytesObj : null,
                                iconId: m.iconId
                            })
                            : null

                        mapOptions.onMapInit = (map: Map) => {
                            this.mapDeferred.resolve(map)

                            this.updateMapSource({
                                markers: $scope.data.markers,
                                polygons: $scope.data.polygons,
                                ranges: $scope.data.ranges
                            }, true)
                        }
                        mapOptions.resetFilter = (): void => {
                            this.mapDeferred.promise().then(map => {
                                this._setMarkers = this.getMarkers(this._markers)
                                map.setMarkers(this._setMarkers, true, true)
                                this.$scope.mapOptions.isFiltered = false
                                this.markersOnMap = this._markers
                                this.$scope.$root.$broadcast(EventsNames.DASHBOARD_MAP_MARKERS_COUNT_CHANGED, this._markers, this.$scope.data.referenceType)
                            })
                        }

                        this.$scope.mapOptions = mapOptions
                    })
            })

            this._markers = $scope.data.markers ? $scope.data.markers.map(marker => jQuery.extend(true, {}, marker)) : []
            this.markersOnMap = $scope.data.markers
            $scope.$root.$broadcast(EventsNames.DASHBOARD_MAP_MARKERS_COUNT_CHANGED, $scope.data.markers, $scope.data.referenceType)
        }

        setTimeout(() => {
            setMapOptions()
        }, 500)

        $scope.$on(EventsNames.UPDATE_DASHBOARD_ITEM + $scope.data.id, (event, ...args) => {
            setMapOptions()
        })

        $scope.$on(EventsNames.DASHBOART_GRID_ROW_SELECTED, (event: ng.IAngularEvent, ...args: any[]) => {
            var referenceValues: any[] = args[0] || []
            var referenceType: number = args[1]
            var correlationType: number = $scope.data.correlationType

            this.showReferenceData(referenceValues, referenceType, correlationType)
        })

        $scope.$on(EventsNames.DASHBOARD_CHART_POINT_CLICKED, (event: ng.IAngularEvent, ...args: any[]) => {
            const referenceValues: any[] = args[0] || []
            const referenceType: number = args[1]
            const correlationType: number = $scope.data.correlationType

            this.showReferenceData(referenceValues, referenceType, correlationType)
        })

        $scope.$on(EventsNames.DASHBOARD_TILE_CLICKED, (event: ng.IAngularEvent, ...args: any[]) => {
            const referenceValues: any[] = args[0] || []
            const referenceType: number = args[1]
            const correlationType: number = $scope.data.correlationType

            this.showReferenceData(referenceValues, referenceType, correlationType)
        })

        $scope.$on(EventsNames.DASHBOARD_SLIDER_SLICKED, (event: ng.IAngularEvent, ...args: any[]) => {
            var slider = args[0]
            var correlationType: number = $scope['correlationType']

            if (correlationType == CorrelationType.None) return
            if (correlationType == CorrelationType.Local) {

                if (slider.referenceType == $scope['referenceType'] && $scope['referenceType']) {
                    var markers = []
                    $scope.data.markers.forEach(m => {
                        if (slider.idObject == m.id) {
                            markers.push(m)
                        }
                    })
                    this.mapDeferred.promise().then(map => {
                        map.setSelectedMarkers(this.getMarkers(markers), true)
                    })
                }
            }
            if (correlationType == CorrelationType.Server) {
                //isnt used for map for now
            }
        })
    }

    updateMapSource(source: MapSource, zoomIn: boolean = false, center: boolean = false) {
        this.mapDeferred.promise().then(map => {
            this._setMarkers = this.getMarkers(source.markers)
            map.setMarkers(this._setMarkers, zoomIn, center)
            this.markersOnMap = this._setMarkers

            if (_.isArray(source.polygons)) {
                map.setPolygons(source.polygons.map((p: DashboardMapPolygon) => {
                    let polygon: OpPolygon = new OpPolygon();

                    polygon.coords = _.map(p.coords, c => {
                        const coord = new OpCoord()

                        coord.latitude = c.latitude
                        coord.longitude = c.longitude

                        return coord;
                    })

                    polygon.fillColor = p.fillColor;
                    polygon.lineColor = p.lineColor;
                    polygon.tooltip = p.tooltip;
                    polygon.fillOpacity = 0.35;
                    polygon.lineOpacity = 0.8;
                    polygon.lineWeight = 2;

                    return polygon
                }))
            }

            if (_.isArray(source.ranges)) {
                map.setRanges(source.ranges.map((r: DashboardMapRange) => {
                    let range: OpRange = new OpRange()

                    range.coords = new OpCoord()
                    range.coords.latitude = r.coords.latitude
                    range.coords.longitude = r.coords.longitude
                    range.fillColor = r.fillColor;
                    range.lineColor = r.lineColor;
                    range.tooltip = r.tooltip;
                    range.fillOpacity = 0.35
                    range.lineOpacity = 0.8
                    range.lineWeight = 2
                    range.radius = r.radius * 1000

                    return range
                }))
            }
        })
    }

    getMarkers(data: any[]) {
        var markers: OpMarker[] = []

        if (data)
            data.forEach(dataRow => {
                var id: number = dataRow.id

                var pos: OpCoord = null

                if (dataRow.hasOwnProperty('coords')) {
                    // dashboard markers
                    // TODO: move it to dashboard
                    var latitude = +dataRow.coords.latitude
                    var longitude = +dataRow.coords.longitude
                    if (!isNaN(latitude) && !isNaN(longitude)) {
                        pos = new OpCoord()
                        pos.latitude = latitude
                        pos.longitude = longitude
                    }
                }

                // add marker
                if (pos) {
                    var marker = new OpMarker()
                    marker.coords = pos
                    marker.referenceValue = id

                    // get marker tooltip
                    if (dataRow.tooltip)
                        marker.tooltip = dataRow.tooltip
                    else if (dataRow.markerString)
                        marker.tooltip = dataRow.markerString
                    else
                        marker.tooltip = id.toString()

                    // get marker icon or color
                    if (dataRow.markerColorReference) {
                        var rgbIconColor = (KnownColor.getColor(dataRow.markerColorReference.toString())).split(',').map(c => +c)
                        marker.fillColor = CommonHelper.rgbToHex(rgbIconColor)
                    }
                    if (dataRow.icon) {
                        marker.iconImage = dataRow.icon
                    } else if (dataRow.color && dataRow.color != '') {
                        var rgb = (<string>dataRow.color).split(', ')
                        if (rgb.length == 3) {
                            marker.fillColor = CommonHelper.rgbToHex(rgb)
                        }
                        else if (rgb.length == 1) {
                            marker.fillColor = rgb.join('').replace('#', '')
                        }
                    }

                    // marker events
                    marker.onClick = (element: OpMarker) => {
                        this.$scope.$root.$broadcast(EventsNames.DASHBOARD_MAP_MARKER_CLICKED, dataRow, this.$scope.data.referenceType)
                    }

                    marker.onDoubleClick = (element: OpMarker) => {
                        if (this.$scope.data.referenceType) {
                            this.systemService.openDetailsOrModule({
                                idReferenceType: this.$scope.data.referenceType,
                                referenceObjectIds: [dataRow.id]
                            })
                        }
                    }

                    markers.push(marker)
                }
            })
        return markers
    }

    private showReferenceData(referenceValues: any[], referenceType: number, correlationType: number): void {
        if (correlationType == CorrelationType.None) {
            return
        }
        if (correlationType == CorrelationType.Local) {
            if (this.$scope.data.referenceType && referenceType == this.$scope.data.referenceType) {
                let markers: any[] = []
                referenceValues.forEach(ref => {
                    this.$scope.data.markers.forEach(m => {
                        if (ref == m.id) {
                            markers.push(m)
                        }
                    })
                })

                let mapInteractionType: Enums.MapInteractionType = this.$scope.data.interaction != null ? this.$scope.data.interaction : Enums.MapInteractionType.MarkerBounce

                this.mapDeferred.promise().then(map => {
                    if (mapInteractionType === Enums.MapInteractionType.MarkerFilter) {
                        setTimeout(() => {
                            const _markers = this.getMarkers(markers)
                            if (this.intervalSourceUpdate) {
                                map.setMarkers(_markers, false, false)
                            } else {
                                map.setMarkers(_markers, true, true)
                                map.setSelectedMarkers(this.getMarkers(markers), true, true)
                            }

                            if (this.$scope.shortDetailsSettings) {
                                this.$scope.shortDetailsSettings.objects = markers
                            }

                            this.$scope.mapOptions.isFiltered = true
                            this.markersOnMap = markers
                            this.$scope.$root.$broadcast(EventsNames.DASHBOARD_MAP_MARKERS_COUNT_CHANGED, markers, this.$scope.data.referenceType)

                        }, 500)
                    } else {
                        let reloadMarkers: boolean = false
                        if (this._setMarkers.length !== this._markers.length) {
                            reloadMarkers = true
                        } else {
                            if (!this._setMarkers.every(x => {
                                return this._markers.some(m => m.id === x.id)
                            })) {
                                reloadMarkers = true
                            }
                        }

                        if (reloadMarkers) {
                            map.setMarkers(this.getMarkers(this._markers), true, true)
                        }
                        if (this.$scope.shortDetailsSettings) {
                            this.$scope.shortDetailsSettings.objects = markers
                        }
                        this.markersOnMap = this._markers
                        this.$scope.$root.$broadcast(EventsNames.DASHBOARD_MAP_MARKERS_COUNT_CHANGED, this._markers, this.$scope.data.referenceType)
                        map.setSelectedMarkers(this.getMarkers(markers), true, true)
                    }
                })
            }
        }
        if (correlationType == CorrelationType.Server) {
            //isnt used for map for now
        }
    }
}